import { Component } from 'preact';
import OptionRowForm from "../form/OptionRowForm";
import ItemsNotFoundForm from "../../common/ItemsNotFoundForm";
import Loader from "../../common/Loader";
import { TABS } from "./../../constants/constants";
import { isDateGreenForOption } from "../../util/GreenChoiceUtils";

export default class RawDateContainer extends Component {

    static defaultProps = {
        options: []
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.checkDefaultOption();
    }

    checkDefaultOption = () => {
        const {options, onSelectOption, exactDate} = this.props;

        if (options?.length) {
            const orderedOptions = exactDate
                ? [
                    ...options.filter(o => isDateGreenForOption(exactDate, o)),
                    ...options.filter(o => !isDateGreenForOption(exactDate, o))
                ]
                : options;

            const firstOption = orderedOptions[0];

            onSelectOption(firstOption.identifier, exactDate);
        }
    };

    render() {
        const {options, onSelectOption, exactDate, config, showGreenChoice, isLoading} = this.props;

        const hasItems = options && options.length > 0;

        const orderedOptions = (hasItems && exactDate)
            ? [...options.filter(o => isDateGreenForOption(exactDate, o)), ...options.filter(o => !isDateGreenForOption(exactDate, o))]
            : options;

        return (
            <form className="options">
                <Loader isLoading={isLoading} className="loader--small"/>

                {!isLoading && !hasItems && <ItemsNotFoundForm tab={TABS.DELIVERY}/>}

                {!isLoading && (
                    <ul className="options__listing" aria-labelledby="delivery-tab-title">
                        {
                            hasItems &&
                            orderedOptions.map((o, index) => <OptionRowForm option={o}
                                    exactDate={exactDate}
                                    onSelectOption={onSelectOption}
                                    config={config}
                                    showGreenChoice={showGreenChoice}
                                    index={index + 1}
                                    total={orderedOptions.length}/>)
                        }
                    </ul>
                )}
            </form>
        );
    }
}